const FORUM_URL = globalThis.location?.hostname?.includes('qa.')
  ? 'https://forum.qa.agilemd.com'
  : 'https://forum.agilemd.com';

interface GlobalLink {
  label: string;
  href: string;
  isActive?: boolean;
  onClick?: () => void;
}

interface BuildGlobalLinksOptions {
  reportsEnabled: boolean;
  adminConsoleEnabled: boolean;
  authoringEnabled: boolean;
  forumEnabled: boolean;
  reviewerEnabled?: boolean;
  studioEnabled?: boolean;
  organizationId?: string;
  activeLink?: 'viewer' | 'author' | 'reviewer' | 'studio' | 'reports' | 'admin-console';
}

export default function buildGlobalLinks({
  reportsEnabled,
  adminConsoleEnabled,
  authoringEnabled,
  forumEnabled,
  reviewerEnabled,
  studioEnabled,
  organizationId,
  activeLink
}: BuildGlobalLinksOptions): GlobalLink[] {
  const orgSuffix = organizationId ? `/organizations/${organizationId}` : '';

  return [
    {
      label: 'Viewer',
      href: `/meta/viewer${orgSuffix}`,
      isActive: activeLink === 'viewer'
    },
    studioEnabled
      ? {
          label: 'Studio',
          href: '/meta/studio',
          isActive: activeLink === 'studio'
        }
      : null,
    !studioEnabled && authoringEnabled
      ? {
          label: 'Author',
          href: `/meta/author${orgSuffix}`,
          isActive: activeLink === 'author'
        }
      : null,
    !studioEnabled && reviewerEnabled
      ? {
          label: 'Reviewer',
          href: '/meta/reviewer',
          isActive: activeLink === 'reviewer'
        }
      : null,
    reportsEnabled
      ? {
          label: 'Reports',
          href: `/meta/reports${orgSuffix}`,
          isActive: activeLink === 'reports'
        }
      : null,
    adminConsoleEnabled
      ? {
          label: 'Admin Console',
          href: `/admin-console${orgSuffix}`,
          isActive: activeLink === 'admin-console'
        }
      : null,
    forumEnabled
      ? {
          label: 'Forum',
          href: FORUM_URL,
          onClick: () => {
            globalThis.open(FORUM_URL, '_blank');
          },
          isActive: false
        }
      : null
  ].filter(Boolean) as GlobalLink[];
}
